// Filo: araçlar, belgeler, bakım, uyum merkezi, QR/NFC cihazları (C26–C30, C69–C73): Control yönlendirmeleri (izin + bayrak korumalı, tembel yüklenir).
import { Navigate, Route } from 'react-router';
import { guard, load } from '../route-utils';

const VehicleList = load(() => import('./VehicleList'), 'VehicleList');
const VehicleDetail = load(() => import('./VehicleDetail'), 'VehicleDetail');
const VehicleForm = load(() => import('./VehicleForm'), 'VehicleForm');
const VehicleDocuments = load(() => import('./VehicleDocuments'), 'VehicleDocuments');
const Maintenance = load(() => import('./Maintenance'), 'Maintenance');
const ComplianceCenter = load(() => import('./ComplianceCenter'), 'ComplianceCenter');
const ExpiringDocuments = load(() => import('./ExpiringDocuments'), 'ExpiringDocuments');
const QrDevices = load(() => import('./QrDevices'), 'QrDevices');
const Stickers = load(() => import('./Stickers'), 'Stickers');
const NfcDevices = load(() => import('./NfcDevices'), 'NfcDevices');

export const fleetRoutes = (
  <>
    <Route path="araclar" element={guard(VehicleList, 'fleet')} />
    <Route path="araclar/yeni" element={guard(VehicleForm, 'fleet', { action: 'edit' })} />
    <Route path="araclar/:id" element={guard(VehicleDetail, 'fleet')} />
    <Route path="araclar/:id/duzenle" element={guard(VehicleForm, 'fleet', { action: 'edit' })} />
    <Route path="araclar/:id/belgeler" element={guard(VehicleDocuments, 'compliance')} />
    <Route path="bakim" element={guard(Maintenance, 'fleet')} />
    <Route path="belge-uyumu" element={guard(ComplianceCenter, 'compliance')} />
    <Route path="belge-uyumu/suresi-dolanlar" element={guard(ExpiringDocuments, 'compliance')} />
    <Route path="cihazlar" element={<Navigate to="/operasyon/cihazlar/qr" replace />} />
    <Route path="cihazlar/qr" element={guard(QrDevices, 'devices')} />
    <Route path="cihazlar/etiketler" element={guard(Stickers, 'devices')} />
    <Route path="cihazlar/nfc" element={guard(NfcDevices, 'devices', { flag: 'NFC' })} />
  </>
);
